import { Empty, Image, Table, TableProps } from 'antd';
import { useEffect, useState } from 'react';

import LoadingComponent from 'components/loadingComponent/loadingComponent';
import NotificationService from 'core/services/notification';
import { onGetInvestments } from 'modules/users/services/users';
import { Investment } from 'modules/users/models/investment';
import { useTranslation } from 'react-i18next';
import NoData from 'components/noData/noData';

interface InputProps {
	id: number;
}

function InvestmentsComponent({ id }: InputProps) {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(true);
	const [investments, setInvestments] = useState<Investment[]>([]);

	useEffect(() => {
		getInvestments();
	}, []);

	const columns: TableProps<Investment>['columns'] = [
		{
			title: t('COMMON.ID'),
			dataIndex: 'id',
			key: 'id',
			render: (id) => <span style={{ fontWeight: 500, color: '#3F4254' }}>{id}</span>,
		},
		{
			title: t('USERS.COMPANY_NAME'),
			dataIndex: 'company_name',
			key: 'company_name',
			render: (company_name) => <span style={{ fontWeight: 500, color: '#7E8299' }}>{company_name}</span>,
		},
		{
			title: t('USERS.COMPANY_LOGO'),
			dataIndex: 'company_logo',
			key: 'company_logo',
			render: (company_logo) => <Image src={company_logo} height={50} />,
		},
		{
			title: t('USERS.AVERAGE_BUYING_PRICE'),
			dataIndex: 'average_buying_price',
			key: 'average_buying_price',
			render: (average_buying_price) => <span style={{ fontWeight: 500, color: '#7E8299' }}>{average_buying_price}</span>,
		},
	];

	const getInvestments = async () => {
		try {
			setIsLoading(true);

			const response = await onGetInvestments(id);
			setInvestments(response.data.data.shareholder_investments);

			setIsLoading(false);
		} catch (error) {
			NotificationService.error(t('COMMON.OPS'), t('COMMON.ERROR_OCCURRED'));
		}
	};

	return (
		<>
			{isLoading ? (
				<LoadingComponent />
			) : (
				<Table rowKey="id" columns={columns} dataSource={investments} scroll={{ x: 400 }} locale={{ emptyText: <NoData /> }} />
			)}
		</>
	);
}

export default InvestmentsComponent;
